module.exports = __webpack_public_path__ + "static/img/en21.63b81a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contact/en21.jpg
// module id = oXw2
// module chunks = 1